import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'connected-react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons/faCircleXmark'
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner'
import {
    Button,
    Icon,
    Menu,
    MenuItem,
    Popover,
    Tooltip,
    Intent,
} from '@blueprintjs/core'
import { DatePicker } from '@blueprintjs/datetime'
import { Popover2 } from '@blueprintjs/popover2'
import * as paths from 'src/constants/paths'
import * as actionTypes from 'src/constants/actionTypes'
import { toggleControl } from 'src/store/modules/ui/runbook/controls'
import {
    asyncEditRunbookActions,
    createRunbook,
    updateRunbook,
    startForecasting,
    exportRunbook,
    exportLogs,
    exportAllRunbook,
} from 'src/store/modules/runbooks'
import { startSession, endSession } from 'src/store/modules/runbooks/sessions'
import ConfirmDialog from 'src/components/ConfirmDialog'
import { LOGS } from 'src/routes/Runbook/Controls/FilterControls'

import styles from './header.module.scss'

class Header extends Component {
    static propTypes = {
        runbook: PropTypes.object.isRequired,
    }

    state = {
        isOpenSessionActions: false,
        isOpenConfirmEndSession: false,
        discardSession: false,
        forecastCalculating: false,
        forecastDate: null,
        forecastPopoverIsOpen: false,
    }

    handleExport = () => {
        const { runbook, actions, dispatch, selectedWindow } = this.props
        selectedWindow === 'actions-list'
            ? actions.exportRunbook(runbook.id, runbook.name)
            : actions.exportLogs(runbook, selectedWindow)

        dispatch({
            type: actionTypes.TOAST_SHOW,
            message: {
                content: `The export has started, it will create a download file shortly.`,
                intent: Intent.PRIMARY,
            },
        })
    }
    handleExportAll = () => {
        const { runbook, actions, dispatch } = this.props
        actions.exportAllRunbook(runbook)
        dispatch({
            type: actionTypes.TOAST_SHOW,
            message: {
                content: `The export has started, it will create a download file shortly.`,
                intent: Intent.PRIMARY,
            },
        })
    }
    handleEdit = () => {
        const { runbook, actions } = this.props

        actions.updateRunbook(runbook.id, { isEditing: true })
    }

    handleGoBack = () => {
        const { dispatch } = this.props

        dispatch(push(paths.LIST_PATH))
    }

    handleCancelEditing = () => {
        const { runbook, actions } = this.props

        actions.updateRunbook(runbook.id, { isEditing: false })
        if (this.props.onCancelEditing) {
            this.props.onCancelEditing()
        }
    }

    handleStartSession = () => {
        const { actions, runbook, dispatch } = this.props

        actions.startSession(dispatch, runbook.id)
    }

    handleConfirmEndSession = () => {
        const { discardSession } = this.state
        const { actions, runbook, dispatch } = this.props

        actions.endSession(
            dispatch,
            runbook.id,
            runbook.activeSession,
            discardSession
        )

        this.setState({ isOpenConfirmEndSession: false })
    }

    handleCancelEndSession = () =>
        this.setState({ isOpenConfirmEndSession: false })

    handleSaveRunbook = () => {
        const { runbook, actions } = this.props

        if (runbook.id) {
            actions.asyncEditRunbookActions(runbook.id)
        } else {
            actions.createRunbook()
        }
    }

    handleEndSession = () => {
        this.setState({
            isOpenConfirmEndSession: true,
            isOpenSessionActions: false,
        })
    }

    handleAddDecision = () => {
        const { actions } = this.props

        this.setState({ isOpenSessionActions: false })
        actions.toggleControl('isInsertingDecision')
    }

    handleAddAnIssue = () => {
        const { actions } = this.props

        this.setState({ isOpenSessionActions: false })
        actions.toggleControl('isInsertingIssue')
    }

    handleForecastDateChange = (forecastDate) => {
        this.setState({ forecastDate: forecastDate })
    }

    handleForecastDateApply = () => {
        if (this.state.forecastDate) {
            this.setState({ forecastPopoverIsOpen: false })
            const { runbook, actions } = this.props
            actions.startForecasting(runbook.id, {
                runbookStartTime: new Date(this.state.forecastDate),
            })
        }
    }

    handleInteraction(nextOpenState) {
        this.setState({ forecastPopoverIsOpen: nextOpenState })
    }

    _renderRunbookTitle() {
        const { runbook } = this.props
        return (
            <div>
                <Icon
                    icon="arrow-left"
                    className={styles.backArrowIcon}
                    onClick={this.handleGoBack}
                    iconSize={28}
                />

                <p className={styles.title} title={runbook.name}>
                    {runbook.name}
                </p>
            </div>
        )
    }

    _renderButtonActions() {
        const { isOpenSessionActions, forecastCalculating } = this.state
        const { runbook, currentUserIsGlobalAdmin, runbookLoading } = this.props
        const { sessionLoading } = runbook
        const canEditOrHandleSession =
            runbook.isAdmin || runbook.isOwner || currentUserIsGlobalAdmin

        const saveRunbookButton = (
            <Button
                icon="tick-circle"
                intent="success"
                large
                className={styles.button}
                onClick={this.handleSaveRunbook}
                disabled={runbook.actions.uids.length === 0 || runbookLoading}
            >
                Save Runbook
            </Button>
        )
        const isDisabled =
            this.props.selectedWindow === LOGS.HISTORY || sessionLoading
        const exportMenu = (
            <Menu>
                <MenuItem
                    icon="export"
                    text="Export Current"
                    disabled={isDisabled}
                    onClick={this.handleExport}
                />
                <MenuItem
                    icon="export"
                    text="Export All"
                    disabled={isDisabled}
                    onClick={this.handleExportAll}
                />
            </Menu>
        )
        return (
            <div>
                {!runbook.isEditing &&
                    (runbook.activeSession ? (
                        <Popover content={exportMenu} position="bottom">
                            <Button
                                icon="export"
                                intent="geyser"
                                large
                                className="button"
                                disabled={isDisabled}
                                rightIcon="caret-down"
                            >
                                Export
                            </Button>
                        </Popover>
                    ) : (
                        <Button
                            icon="export"
                            intent="geyser"
                            large
                            className={styles.button}
                            onClick={this.handleExport}
                            disabled={
                                this.props.selectedWindow === LOGS.HISTORY ||
                                sessionLoading
                            } // History export disabled until export is moved to export center, size too big
                        >
                            Export
                        </Button>
                    ))}
                {!runbook.isEditing && !runbook.activeSession ? (
                    <Popover2
                        content={
                            <div style={{ backgroundColor: 'white' }}>
                                <DatePicker
                                    value={runbook.potentialStartTime}
                                    onChange={this.handleForecastDateChange}
                                    timePickerProps={{
                                        precision: 'minute',
                                        showArrowButtons: true,
                                    }}
                                />
                                <div className={styles.foreCastButtonWrapper}>
                                    <Button
                                        intent="primary"
                                        onClick={this.handleForecastDateApply}
                                    >
                                        Apply selection
                                    </Button>
                                    <Button
                                        intent="naked"
                                        className={styles.cancelButton}
                                        onClick={() =>
                                            this.handleInteraction(false)
                                        }
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </div>
                        }
                        isOpen={this.state.forecastPopoverIsOpen}
                        onInteraction={(state) => this.handleInteraction(state)}
                    >
                        <Button
                            icon={
                                forecastCalculating ? (
                                    <FontAwesomeIcon icon={faSpinner} />
                                ) : (
                                    'time'
                                )
                            }
                            intent="geyser"
                            large
                            className={styles.button}
                            disabled={sessionLoading}
                        >
                            <span>Forecast start time</span>
                            <Icon icon="chevron-down" />
                        </Button>
                    </Popover2>
                ) : null}

                {!runbook.isEditing && !runbook.activeSession ? (
                    <Button
                        icon="edit"
                        intent="tarawera"
                        large
                        className={styles.button}
                        onClick={this.handleEdit}
                        disabled={!canEditOrHandleSession || sessionLoading}
                    >
                        Edit runbook
                    </Button>
                ) : null}
                {runbook.isEditing && runbook.id ? (
                    <Button
                        icon={<FontAwesomeIcon icon={faCircleXmark} />}
                        minimal
                        large
                        className={`${styles.button} ${styles.cancelButton}`}
                        onClick={this.handleCancelEditing}
                        disabled={!canEditOrHandleSession}
                    >
                        Cancel editing
                    </Button>
                ) : null}
                {!runbook.isEditing && !runbook.activeSession ? (
                    <Button
                        icon="play"
                        intent="primary"
                        large
                        className={classNames(styles.button, styles.playButton)}
                        onClick={this.handleStartSession}
                        disabled={!canEditOrHandleSession || sessionLoading}
                    >
                        Start session
                    </Button>
                ) : null}
                {!runbook.isEditing && runbook.activeSession ? (
                    <Popover2
                        minimal
                        position="bottom-right"
                        isOpen={isOpenSessionActions}
                        onClose={() =>
                            this.setState({
                                isOpenSessionActions: false,
                            })
                        }
                        content={
                            <Menu>
                                <MenuItem
                                    icon="symbol-square"
                                    text="End session"
                                    onClick={this.handleEndSession}
                                />
                                <MenuItem
                                    icon="comment"
                                    text="Add decision"
                                    onClick={this.handleAddDecision}
                                />
                                <MenuItem
                                    icon="issue"
                                    text="Add an issue"
                                    onClick={this.handleAddAnIssue}
                                />
                            </Menu>
                        }
                    >
                        <Button
                            icon={isOpenSessionActions ? 'cross' : 'menu'}
                            intent="success"
                            large
                            className={styles.button}
                            onClick={() =>
                                this.setState({
                                    isOpenSessionActions: !isOpenSessionActions,
                                })
                            }
                            disabled={!canEditOrHandleSession}
                        >
                            Session actions
                        </Button>
                    </Popover2>
                ) : null}
                {runbook.isEditing ? (
                    runbook.actions.uids.length === 0 ? (
                        <Tooltip
                            content="Runbook must have at least one action"
                            position="bottom"
                        >
                            {saveRunbookButton}
                        </Tooltip>
                    ) : (
                        saveRunbookButton
                    )
                ) : null}
            </div>
        )
    }

    _renderConfirmEndSession() {
        const { isOpenConfirmEndSession } = this.state

        return (
            <ConfirmDialog
                title="Are you sure you want to end this session? This will
                         reset all actions statuses"
                isOpen={isOpenConfirmEndSession}
                confirmLabel="End"
                confirmIntent="primary"
                onConfirm={this.handleConfirmEndSession}
                onCancel={this.handleCancelEndSession}
            />
        )
    }

    render() {
        return (
            <div className={styles.root}>
                {this._renderRunbookTitle()}
                {this._renderButtonActions()}
                {this._renderConfirmEndSession()}
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    dispatch,
    actions: bindActionCreators(
        {
            asyncEditRunbookActions,
            createRunbook,
            endSession,
            startSession,
            toggleControl,
            updateRunbook,
            startForecasting,
            exportRunbook,
            exportLogs,
            exportAllRunbook,
        },
        dispatch
    ),
})

const mapStateToProps = (state) => {
    return {
        currentUserIsGlobalAdmin: state.app.isAdmin,
        runbookLoading: state.ui.runbook.runbookLoading,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
